import { useEffect, useState } from 'react';

import { useSettings } from '../settings';
import { fetchAvatarObjectUrlByEmail } from './api';

const resolved = new Map<string, string | null>();
const inflight = new Map<string, Promise<string | null>>();

const cacheKey = (org: string, email: string): string => `${org}|${email}`;

const loadAvatar = (org: string, pat: string, email: string): Promise<string | null> => {
    const key = cacheKey(org, email);
    const cached = resolved.get(key);
    if (cached !== undefined) {
        return Promise.resolve(cached);
    }
    const existing = inflight.get(key);
    if (existing) {
        return existing;
    }
    const p = fetchAvatarObjectUrlByEmail(org, pat, email)
        .then((u) => {
            resolved.set(key, u);
            return u;
        })
        .catch(() => null)
        .finally(() => {
            inflight.delete(key);
        });
    inflight.set(key, p);
    return p;
};

export const useMemberAvatar = (email: string): string | null => {
    const { settings, configured } = useSettings();
    const [url, setUrl] = useState<string | null>(() => {
        if (!configured || !email) {
            return null;
        }
        const cached = resolved.get(cacheKey(settings.org, email));
        return cached === undefined ? null : cached;
    });

    useEffect(() => {
        if (!configured || !email) {
            return;
        }
        let cancelled = false;
        loadAvatar(settings.org, settings.pat, email).then((u) => {
            if (!cancelled) {
                setUrl(u);
            }
        });
        return () => {
            cancelled = true;
        };
    }, [configured, email, settings.org, settings.pat]);

    return url;
};
